import {toUpper} from "lodash";
import { markRaw } from "vue";
import { toast } from 'vue-sonner';
import 'vue-sonner/style.css'
import SuccessToast from "@/components/micro/SuccessToast.vue";

const myPlugin = {
    install(app) {

        // Price formatting
        app.config.globalProperties.$priceFormat = (price, company) => {

            if (company === 'Pacific Destinations') {
                return Number(price / 100).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'NZD'
                })
            } else if (company === 'Goway Inbound') {
                return Number(price / 100).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'AUD'
                })
            } else {
                return Number(price / 100).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'NZD'
                })
            }
        }

        // Price formatting
        app.config.globalProperties.$priceFormatNormal = (price, company) => {

            if (company === 'Pacific Destinations') {
                return Number(price ).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'NZD'
                })
            } else if (company === 'Goway Inbound') {
                return Number(price ).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'AUD'
                })
            } else {
                return Number(price ).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'NZD'
                })
            }
        }

        // Price formatting
        app.config.globalProperties.$priceFormatNoCurrency = (price) => {
            const value = price / 100;
            return value % 1 === 0
                ? value.toLocaleString()          // no decimals if integer
                : value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }

        // Strip pre tags
        app.config.globalProperties.$stripPreTags = (key) => {

            return key.replace(/<pre data-placeholder="Translation" dir="ltr">(.*?)<\/pre>/gs, '$1')

        }

        // Convert to friendly date
        app.config.globalProperties.$readableDate = (key) => {
            if (!key || typeof key !== 'string') {
                return '';
            }

            const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            var monthNum = key.substring(5, 7)
            var month = months[monthNum - 1]
            var day = key.substring(8, 10)

            return day + ' ' + month
        }

        // Convert to friendly date including year
        app.config.globalProperties.$readableDateAndYear = (key) => {
            if (!key || typeof key !== 'string') {
                return '';
            }

            const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            var monthNum = key.substring(5, 7)
            var year = key.substring(0, 4)
            var month = months[monthNum - 1]
            var day = key.substring(8, 10)

            return day + ' ' + month + ' ' + year
        }

        app.config.globalProperties.$readableDateAndDayName = (key) => {
            if (!key || typeof key !== 'string') {
                return '';
            }

            const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

            var monthNum = key.substring(5, 7);
            var year = key.substring(0, 4);
            var month = months[monthNum - 1];
            var day = key.substring(8, 10);

            var date = new Date(year, monthNum - 1, day);
            var dayName = days[date.getDay()];

            return dayName + ', ' + day + ' ' + month;
        }

        // Convert to friendly date including year and weekday
        // app.config.globalProperties.$readableDateWithWeekday = (key) => {
        //     const d = new Date(key);
        //
        //     const weekday = d.toLocaleDateString('en-GB', { weekday: 'short' });
        //     const day = String(d.getDate()).padStart(2, '0');
        //     const month = d.toLocaleDateString('en-GB', { month: 'short' });
        //     const year = String(d.getFullYear()).slice(-2);
        //
        //     return `${weekday} ${day} ${month} ${year}`;
        // }
        app.config.globalProperties.$readableDateWithWeekday = (key) => {
            const [year, month, day] = key.split('-').map(Number)

            const date = new Date(Date.UTC(year, month - 1, day))

            const weekday = date.toLocaleDateString('en-GB', {
                weekday: 'short',
                timeZone: 'UTC'
            })

            const monthName = date.toLocaleDateString('en-GB', {
                month: 'short',
                timeZone: 'UTC'
            })

            return `${weekday} ${String(day).padStart(2, '0')} ${monthName} ${String(year).slice(-2)}`
        }

        // Convert to NZ date
        app.config.globalProperties.$nzDate = (str, separator = false) => {
            if (!str || typeof str !== 'string') return ''
            let parts = str.split('/')
            if(separator){
                parts = str.split('-')
            }
            if (parts.length !== 3) return ''
            let [day, month, year] = parts
            if(separator){
                [year, month, day] = parts
            }
            return `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`
        }

        // Convert to day name (Mon, Tue, Wed etc)
        app.config.globalProperties.$dayName = (key) => {
            if (!key || typeof key !== 'string') {
                return '';
            }

            const date = new Date(key);

            if (isNaN(date.getTime())) {
                return '';
            }

            const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
            const dayIndex = date.getDay();

            return days[dayIndex];
        };

        // Convert UTC timestamps to local
        // Date / time formatting
        app.config.globalProperties.$dateTimeFormat = (utcString, company) => {
            if (!utcString) return null;

            let timeZone = 'Pacific/Auckland'; // default NZ

            if (company === 'Goway Inbound') {
                timeZone = 'Australia/Sydney';
            } else if (company === 'Pacific Destinations') {
                timeZone = 'Pacific/Auckland';
            }

            const date = new Date(utcString);

            return new Intl.DateTimeFormat('en-NZ', {
                timeZone: timeZone,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true
            })
            .format(date)
            .replace(/\bam\b/i, 'AM')
            .replace(/\bpm\b/i, 'PM');
        };

        app.config.globalProperties.$dateOnlyFormat = (utcString, company) => {
            if (!utcString) return null;

            let timeZone = 'Pacific/Auckland'; // default NZ

            if (company === 'Goway Inbound') {
                timeZone = 'Australia/Sydney';
            } else if (company === 'Pacific Destinations') {
                timeZone = 'Pacific/Auckland';
            }

            const date = new Date(utcString);

            return new Intl.DateTimeFormat('en-NZ', {
                timeZone: timeZone,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            }).format(date);
        };

        // Convert room code to room name
        app.config.globalProperties.$roomName = (key) => {
            key = toUpper(key)
            if (key === 'DB') {
                return 'Double Room'
            } else if (key === 'SG') {
                return 'Single Room'
            } else if (key === 'TW') {
                return 'Twin Room'
            } else if (key === 'TR') {
                return 'Triple Room'
            } else if (key === 'QD') {
                return 'Quad Room'
            } else if (key === 'OT') {
                return 'Other Room'
            } else {
                return ''
            }
        }

        // Convert room code to room name
        app.config.globalProperties.$roomNameOnly = (key) => {
            key = toUpper(key)
            if (key === 'DB') {
                return 'Double'
            } else if (key === 'SG') {
                return 'Single'
            } else if (key === 'TW') {
                return 'Twin'
            } else if (key === 'TR') {
                return 'Triple'
            } else if (key === 'QD') {
                return 'Quad'
            } else if (key === 'OT') {
                return 'Other'
            } else {
                return ''
            }
        }

        app.config.globalProperties.$paxList = (key) => {
            let str = ''
            Object.entries(key).forEach(([i, val]) => {
                if(val > 0){
                    str += ', ' + val + ' ' + i.charAt(0).toUpperCase() + i.slice(1)
                }
            })
            return str.slice(2)
        }

        app.config.globalProperties.$roomList = (key) => {
            const room_name = {
                db: 'Double',
                sg: 'Single',
                tw: 'Twin'
            }
            const result = key
                .filter(room => room.count > 0)
                .map(room => `${room.count} ${room_name[room.type]} Room${room.count > 1 ? 's' : ''}`)
                .join(', ');
            return result
        }

        // Convert room code to room name
        app.config.globalProperties.$readableTime = (time) => {
            return time.slice(0, 2) + ':' + time.slice(2)
        }

        // Convert room code to room name
        app.config.globalProperties.$readableTime12Hr = (time) => {
            const time24 = time.slice(0, 2) + ':' + time.slice(2)
            return new Date(`1970-01-01T${time24}:00`).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
        }

        // Trim string length
        app.config.globalProperties.$trimString = (string, length) => {
            if (string.length > length) {
                return string.slice(0, length) + '...'
            } else {
                return string
            }
        }

        // Capitalize first letter
        app.config.globalProperties.$capitalizeFirstLetter = (string) => {
            return string[0].toUpperCase() + string.slice(1);
        }

        // Remove -cl from supplier confirmations
        // app.config.globalProperties.$cleanSupplierConfirmation = (confirmation) => {
        //     confirmation = confirmation.replaceAll(' -cl', '');
        //     confirmation = confirmation.replaceAll(' -ar', '');
        //     confirmation = confirmation.replaceAll(' -rc', '');
        //     return confirmation
        // }

        //  Pluralise based on a quantity
        app.config.globalProperties.$pluralise = (quantity) => {
            return quantity <= 1 ? '' : 's';

        }

        // Copy text to clipboard
        app.config.globalProperties.$copyToClipboard = (text, msg = "") => {
            navigator.clipboard.writeText(text);
            if(msg !== ''){
                toast.custom(markRaw(SuccessToast), {
                    componentProps: {
                        message: msg
                    }
                });
            }
        }

        //  Return tailwind classes for different tourplan statuses
        app.config.globalProperties.$getColorClass = (val) => {

            if (typeof val !== 'string') {
                console.warn('Expected a string, but received:', val)
                return ''
            }

            const greenStatuses = ['Confirmed', 'Allotment', 'Available', 'Conf']
            const amberStatuses = ['Quote', 'Processing', 'On Request', 'Requested', 'Mixed', 'pending', 'Wait', 'Amendment']
            const redStatuses = ['Cancelled', 'Unable', 'Cancellation', 'Unavailable', 'Full']

            if (greenStatuses.some(function(status) { return val.indexOf(status) !== -1; })) {
                return 'text-green-500 dark:text-green-400';
            } else if (amberStatuses.some(function(status) { return val.indexOf(status) !== -1; })) {
                return 'text-amber-500 dark:text-amber-400';
            } else if (redStatuses.some(function(status) { return val.indexOf(status) !== -1; })) {
                return 'text-red-500 dark:text-red-400';
            }
            return ''

        }

        app.config.globalProperties.$getBgColorClass = (val) => {

            if (typeof val !== 'string') {
                console.warn('Expected a string, but received:', val)
                return ''
            }

            const greenStatuses = ['Confirmed', 'Allotment', 'Available', 'Conf']
            const amberStatuses = ['Quote', 'Processing', 'On Request', 'Requested', 'Mixed', 'pending', 'Wait', 'Amendment']
            const redStatuses = ['Cancelled', 'Unable', 'Cancellation', 'Unavailable', 'Full']

            if (greenStatuses.some(function(status) { return val.indexOf(status) !== -1; })) {
                return 'bg-green-50 border-green-200 dark:bg-slate-800 dark:text-green-300';
            } else if (amberStatuses.some(function(status) { return val.indexOf(status) !== -1; })) {
                return 'bg-amber-50 border-amber-200 dark:bg-slate-800  dark:text-amber-300';
            } else if (redStatuses.some(function(status) { return val.indexOf(status) !== -1; })) {
                return 'bg-red-100 border-red-200 dark:bg-slate-800 dark:text-red-400';
            }
            return ''

        }

        //  Get a date in the past calculated using provided length in days. Used for limiting dateFrom in search forms.
        app.config.globalProperties.$getPastDate = (length) => {
            // Create a new Date object with today's date
            const today = new Date();

            // Subtract the length from today's date
            today.setDate(today.getDate() - length);

            // Get the year, month, and day
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const day = String(today.getDate()).padStart(2, '0');

            // Return the date as YYYY-MM-DD
            return `${year}-${month}-${day}`;
        }

        // Button Names
        app.config.globalProperties.$buttonName = (srv) => {
            const buttons = {
                'AC': 'Accommodation',
                'AF': 'Accommodation',
                'AT': 'Sightseeing',
                'CR': 'Sightseeing',
                'GU': 'Guides',
                'IN': 'Interisland Ferry',
                'IT': 'Sightseeing',
                'RC': 'Rental Cars',
                'SU': ' ',
                'TN': 'Train',
                'TR': 'Transfers',
                'WK': 'Guided Walks'
            }
            return buttons[srv];
        }

        app.config.globalProperties.$checkoutDate = (checkInDate, nights) => {
            const date = new Date(checkInDate);
            date.setDate(date.getDate() + nights);

            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
            const day = String(date.getDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
        }
    }
}

export default myPlugin;
